import * as React from "react";
import { Layout } from "antd";
import { Analytics } from "./components/Analytics";
import { AnalyticsFilter } from "../../components/AnalyticsFilter";
import { StoreAnalytics } from "../../store/storeAnalytics";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import Paths from "../../constants/PathsBreadcrumbs";

const store = new StoreAnalytics();

const SitAnalytics: React.FC = () => {
  useBreadcrumbs(Paths.spAnalytics);
  const onCloseAnalytics = () => {};

  return (
    <Layout
      className="container"
      style={{ flexDirection: "row", height: "100vh" }}
    >
      <div className={"analytics-filter-custom"}>
        <AnalyticsFilter store={store} onCloseAnalytics={onCloseAnalytics} />
      </div>
      <Layout className="site-layout">
        <Analytics store={store} />
      </Layout>
    </Layout>
  );
};

export default SitAnalytics;
